import { render, staticRenderFns } from "./opendeal.vue?vue&type=template&id=6c617a54&scoped=true&"
import script from "./opendeal.vue?vue&type=script&lang=js&"
export * from "./opendeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c617a54",
  null
  
)

export default component.exports